
export enum AccountManagerEmployeeAggregation {
  // offers aggregation is used for 'outstanding offers', 'seller countered', and 'all offers from selected dealer' filters
  OFFERS = 'employeeDealerMap',
  WINNING_BIDS_OFFERS = 'employeeSoldWonByDealerMap',
  LOSING_BIDS_OFFERS = 'employeeSoldLostByDealerMap',
  ACTIVE_BIDS = 'employeeBidsDealerMap',
  OFFER_LISTS = 'employeeOfferListsDealerMap'
}

// this map is for the subaggregation term
export const AccountManagerEmployeeAggregationDealerMap = {
  [AccountManagerEmployeeAggregation.OFFERS]: 'buyerOeUuid',
  [AccountManagerEmployeeAggregation.WINNING_BIDS_OFFERS]: 'buyer',
  [AccountManagerEmployeeAggregation.LOSING_BIDS_OFFERS]: 'losingDealers',
  [AccountManagerEmployeeAggregation.ACTIVE_BIDS]: 'buyerOeUuid',
  [AccountManagerEmployeeAggregation.OFFER_LISTS]: 'buyerOeUuid'
}
